import { PostHog } from '@posthog/types';
import { User } from '@/types';

/**
 * PostHog is initialized in `resources/views/app.blade.php` on `window.posthog`.
 * The `posthog-js` npm default export is a different, uninitialized singleton — do not use it here.
 */
export function getPosthog(): PostHog | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }

    return window.posthog;
}

export function identifyUser(user: User) {
    const posthog = getPosthog();
    const userId = String(user.id);

    if (posthog) {
        if (
            posthog.get_distinct_id?.() !== userId ||
            posthog.get_property('email') !== user.email ||
            posthog.get_property('name') !== user.name ||
            posthog.get_property('workspace_id') !== user.current_team_id
        ) {
            posthog.identify(userId, {
                email: user.email,
                name: user.name,
                workspace_id: user.current_team_id,
            });
        }
    }
}
